import React from 'react';


export const Block = ( {element} ) => {

    return(
        <div style={element.style.container}></div>
    )
}